import md5 from 'md5';

import { isObject, queryString, removeNulls } from '../utils/core';

export const reactAppApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const doRequest = async (endpoint, { $rawMode, $textMode, ...config } = {}) => {
  const response = await fetch(endpoint, config);
  console.log(`Fetch ${config.method} ${endpoint}: ${response.status}`);
  if ($rawMode) {
    return response;
  }
  if ($textMode) {
    return response.text();
  }
  // process as json
  if (!response.ok) {
    const txt = await response.text();
    const err = isObject(txt) ? txt : JSON.parse(txt || '{}');
    const { error: msg = `${txt}` } = err;
    throw new Error(msg, err);
  }
  let data = await response.json();
  data = removeNulls(data);
  return data;
};

const activeRequests = {};
export const serverRequest = async (path, config = {}) => {
  const {
    apiUrl = reactAppApiUrl,
    body,
    jwt,
    method = body ? 'POST' : 'GET',
    ...customConfig
  } = config;
  let { params = {} } = config;
  try {
    const headers = { 'content-type': 'application/json', accept: 'application/json' };
    config = {
      method,
      ...customConfig,
      headers: {
        ...(jwt && { Authorization: `Bearer ${jwt}` }),
        ...headers,
        ...customConfig.headers,
      },
      mode: 'cors',
    };
    if (body) {
      config.body = config.headers['content-type'] === 'application/x-www-form-urlencoded'
        ? new URLSearchParams(body).toString() : JSON.stringify(body);
    }
    // add params?
    params = removeNulls(params);
    if (Object.keys(params).length) {
      path = `${path}?${queryString(params)}`;
    }
    // issue request, check for duplicate requests
    const key = md5(JSON.stringify({ path, config }));
    const endpoint = `${apiUrl}/${path.replace(/^\//, '')}`;
    try {
      if (activeRequests[key]) {
        console.log(`Fetch ${config.method} ${endpoint}: already in progress, waiting ...`);
      }
      activeRequests[key] = activeRequests[key] || doRequest(endpoint, config);
      return await activeRequests[key];
    } finally {
      delete activeRequests[key];
    }
  } catch (e) {
    console.error('API Error: ', e);
    throw e;
  }
};

export const checkPulse = () => serverRequest('/monitor/heartbeat');
